<div class="modal" [dataSelector]="dataSelector">
  <div class="modal__cont" [dataSelector]="dataSelector + '-content'">
    <div class="h3 modal__title" [dataSelector]="dataSelector + '-title'">Confirm New Version</div>
    <div class="modal__text" [dataSelector]="dataSelector + '-text'">
      <p class="modal__message">
        The file you uploaded has a different name. Adding it as a new version will not change the displayed file name — it will remain:
      </p>
      <div class="modal__filename">
        <strong>{{ data.originalFileName }}.{{ data.originalExtension }}</strong>
      </div>
    </div>
    <div class="modal__buttons" [dataSelector]="dataSelector + '-buttons'">
      <button andButton color="default" (click)="onCancel()" [dataSelector]="dataSelector + '-cancel-button'">Cancel</button>
      <button andButton color="primary" type="submit" (click)="onConfirm()" [dataSelector]="dataSelector + '-confirm-button'">Okay</button>
    </div>
  </div>
</div>